import React, {Component} from "react"
import {OverlayTrigger, Popover} from "react-bootstrap"

class InfoPopover extends Component {
  render() {
    const popoverLeft = (
      <Popover style={{zIndex:10000}}>
        {this.props.desc}
      </Popover>
    )

    return (
      <OverlayTrigger trigger="click" placement="left" overlay={popoverLeft}>
        <i className="fa fa-info-circle custom-link"/>
      </OverlayTrigger>
    )
  }
}

export default InfoPopover



// WEBPACK FOOTER //
// ./src/components/InfoPopover.js